module.exports = __webpack_public_path__ + "static/img/aruxpay_logo_big.27980e36.svg";